import { h, JSX } from "preact";

import RawColor from "../../../foundation/api/model/colors/RawColor";
import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./TextureBackground.module.css";

enum Variant {
    Light = "light",
    Dark = "dark",
    Custom = "custom"
}

interface BaseProps extends JSX.HTMLAttributes<HTMLDivElement> {
    absolute?: boolean;
}

interface VariantProps {
    variant?: Variant.Light | Variant.Dark;
    color?: never;
}

interface CustomProps {
    variant: Variant.Custom;
    color: RawColor;
}

type Props = BaseProps & (VariantProps | CustomProps);

function TextureBackground({
    class: cssClass,
    variant = Variant.Light,
    color,
    absolute,
    style: nativeStyle,
    ...nativeDivProps
}: Props) {
    const style = {
        ...(typeof nativeStyle === "string" ? {} : nativeStyle),
        "--texture-custom-color": color ? `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})` : undefined
    } as CSSProperties;

    return (
        <div class={classname(styles.textureBackground, cssClass, {
            [styles.dark]: variant === Variant.Dark,
            [styles.absolute]: absolute,
            [styles.custom]: color !== undefined
        })}
        style={style}
        {...nativeDivProps}/>
    );
}

export default TextureBackground;
export {
    Variant as TextureBackgroundVariant
};
